import React from 'react';
import { handleActionError } from '../../utils/engineering-tools';
import { TimkenGreaseFillOption } from '../../../components/bearing-search/types/types';
import { thickenerTypes } from '../../../components/bearing-search/api/api';

export type GreaseRelubricationState = {
	option: TimkenGreaseFillOption;
	thickerTypeCode: string;
};

export const initialGreaseRelubricationState: GreaseRelubricationState = {
	option: 'PartNumber',
	thickerTypeCode: thickenerTypes[ 0 ]?.code,
};

export type GreaseRelubricationAction =
	| { type: 'change_option'; payload: TimkenGreaseFillOption }
	| { type: 'change_thickener_type'; payload: string }
	| { type: 'reset'; payload?: GreaseRelubricationState };

const greaseRelubricateReducer: React.Reducer<
	GreaseRelubricationState,
	GreaseRelubricationAction
> = ( state, action ) => {
	switch ( action.type ) {
		case 'change_option': {
			return {
				...state,
				option: action.payload,
			};
		}
		case 'change_thickener_type': {
			return {
				...state,
				thickerTypeCode: action.payload,
			};
		}
		case 'reset': {
			const newState = action.payload ? action.payload : initialGreaseRelubricationState;

			return {
				...newState,
			};
		}
	}

	return handleActionError( action );
};

export default greaseRelubricateReducer;
